// shit
import { dispatcher, serverData, StateController } from '@aceroll/core';

// dispatchers
import { gameDispatcher, slotDispatcher, userConfigDispatcher } from '@aceroll/core';

class SpinStopController extends StateController {
    slotMachine = null;

    constructor() {
        super("spin.stop");
    }

    async onStart() {
        const { gameType } = gameDispatcher.state;
        const { slotMachine } = dispatcher.app.layout;
        const { symbols } = serverData.currentResponse;
        const { gridWonSymbols } = serverData.currentResponse.parsed;
        const { mode } = userConfigDispatcher.state;

        slotDispatcher.updateSymbols(symbols, gameType, gridWonSymbols);

        const anticipation = this.getAnticipation(symbols, 12);

        if (anticipation && mode !== 'superTurbo' && !serverData.activeFeatureBuyData) {
            await slotMachine.anticipation(anticipation);
        } else {
            await slotMachine.stop();
        }

        userConfigDispatcher.unsubscribeSlamStop();
        userConfigDispatcher.restoreMode();

        this.stop();
    }

    getAnticipation(symbols, scatterId) {
        let reelIndex = null;
        let scatterCount = 0;

        for (let i = 0; i < symbols.length - 1; i++) {
            if (scatterCount >= 2) {
                break;
            }

            const reel = symbols[i];

            for (let j = 0; j < reel.length; j++) {
                const cell = reel[j];

                if (cell !== scatterId) {
                    continue;
                }

                scatterCount += 1;

                if (scatterCount >= 2) {
                    reelIndex = i + 1;
                    break;
                }
            }
        }

        return reelIndex;
    }

    onStop() {

    }
}

export default SpinStopController;